import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import { useField, useFormikContext } from 'formik'

import FormGroup from '../FormGroup'
import DefaultFieldProps from '../FormGroup/DefaultFieldProps'

import './overrides.less'

type Props = DefaultFieldProps & {
  format?: string
  picker?: 'time' | 'date' | 'week' | 'month' | 'year'
  monthValue?: 'firstDayOfMonth' | 'lastDayOfMonth'
  placeholder?: string
  id?: string
  className?: string
  allowClear?: boolean
  disabledDate?: (date: any) => boolean
  hideError?: boolean
  disabled?: boolean
  onChange?: (value: { date: any; dateString: string }) => void
  popupClassName?: string
}

const DateValueFormat = 'YYYY-MM-DD'
const DefaultDateDisplayFormat = 'MM/DD/YYYY'
const DefaultMonthPickerDisplayFormat = 'MMM YYYY'

const FormikDatePickerFieldV2 = (props: Props) => {
  const [field, meta] = useField(props.name)
  const context = useFormikContext()

  const onDateChangeHandler = (date: any, dateString: string) => {
    if (!date) {
      context.setFieldValue(props.name, null)
      props.onChange?.({ date: null, dateString: null })
      return
    }

    const resultDate =
      props.picker === 'month'
        ? props.monthValue === 'lastDayOfMonth'
          ? dayjs(date).endOf('month')
          : dayjs(date).set('date', 1)
        : dayjs(date)

    context.setFieldValue(props.name, resultDate.format(DateValueFormat))
    if (props.onChange) {
      props.onChange({ date: resultDate, dateString: resultDate.format(DateValueFormat) })
    }
  }
  return (
    <FormGroup {...props}>
      <DatePicker
        {...props}
        className={'datepickerWrap'}
        allowClear={props.allowClear ?? true}
        picker={props.picker}
        value={
          typeof field.value === 'string' || field.value instanceof String
            ? dayjs(field.value as string, DateValueFormat)
            : null
        }
        format={props.format ?? props.picker === 'month' ? DefaultMonthPickerDisplayFormat : DefaultDateDisplayFormat}
        disabledDate={props.disabledDate}
        onChange={onDateChangeHandler}
      />
    </FormGroup>
  )
}

export default FormikDatePickerFieldV2
